import { useEffect } from "react";

const SpotifyPage = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("access_token");
    console.log(token);
    if (token) {
      localStorage.setItem("spotify_token", token);
      // 사용자 정보 요청 등 가능
    }
  }, []);

  return <div>Spotify 인증 완료</div>;
}

export default SpotifyPage;